/* ui/game/StartButton.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_custom_element_data
} from "svelte/internal";

import { APP, tournamentModeStore } from "../store";

function create_fragment(ctx) {
	let sl_button;
	let mounted;
	let dispose;

	return {
		c() {
			sl_button = element("sl-button");

			sl_button.innerHTML = `<sl-icon slot="prefix" name="play"></sl-icon>
  Start
`;

			set_custom_element_data(sl_button, "type", "primary");
			set_custom_element_data(sl_button, "size", "small");
		},
		m(target, anchor) {
			insert(target, sl_button, anchor);

			if (!mounted) {
				dispose = listen(sl_button, "click", /*handleClick*/ ctx[0]);
				mounted = true;
			}
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(sl_button);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self) {
	function handleClick() {
		tournamentModeStore.update(() => false);
		APP.ticker.start();
	}

	return [handleClick];
}

class StartButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default StartButton;